import { BenefitTableExampleExtendPage } from 'core/service/pdf-generation/products/investment/components'

export const BenefitTableExampleGroup = (props) => {
  const { displayProduct, commonCashFlow, withInflationCashFlow } = props
  const EXPECTED_RETURN_RATES = Object.keys(commonCashFlow.cashFlowByExpectedReturn).sort()
  const table = []
  EXPECTED_RETURN_RATES.forEach((rate, index) => {
    const cashFlows = commonCashFlow.cashFlowByExpectedReturn[rate]
    const inflationRate = 0
    const caseNumber = index + 1
    table.push(
      BenefitTableExampleExtendPage(
        {
          ...commonCashFlow,
          displayProduct,
          cashFlows,
          cashFlowByExpectedReturn: commonCashFlow.cashFlowByExpectedReturn,
        },
        caseNumber,
        parseInt(rate),
        parseInt(inflationRate)
      )
    )
  })

  if (withInflationCashFlow) {
    const EXPECTED_RETURN_RATES_WITH_INFLATION = Object.keys(withInflationCashFlow.cashFlowByExpectedReturn).sort()
    EXPECTED_RETURN_RATES_WITH_INFLATION.forEach((rate, index) => {
      const cashFlows = withInflationCashFlow.cashFlowByExpectedReturn[rate]
      // Continue the case number
      const inflationRates = Object.keys(cashFlows)
      const caseNumber = EXPECTED_RETURN_RATES.length + index + 1
      inflationRates.forEach((inflationRate) => {
        table.push(
          BenefitTableExampleExtendPage(
            {
              ...withInflationCashFlow,
              displayProduct,
              cashFlows: cashFlows[inflationRate],
              cashFlowByExpectedReturn: cashFlows,
            },
            caseNumber,
            parseInt(rate),
            parseInt(inflationRate)
          )
        )
      })
    })
  }

  return table
}
